import {CircleMarker, Marker, Rectangle, useMap} from "react-leaflet";
import L from "leaflet";
import getTeamColor from "./util/color";
import {memo, useEffect, useMemo, useState} from "react";


const TextLabel = ({labelID, position, text, onClickCallback}) => {

    return (
        <Marker
            key={labelID}
            position={position} // Shift right by 200 units
            icon={L.divIcon({
                className: "custom-label",
                html: `<div style="white-space: nowrap; font-size: 12px; color : rgba(255,255,255,1.0 ); background: rgba(255,255,255,0.0); padding: 1px 1px; border-radius: 1px;">${text}</div>`,
                iconSize: [100, 20],
                iconAnchor: [-10, 10],
            })}
            eventHandlers={{
                click: onClickCallback
            }}
        />
    )
}



const PlayerShape = ({position, color, rectangle, onClickCallback, ID}) => {
    const map = useMap();

    if (rectangle) {
        const coord = map.project(position);
        const top_left = map.unproject([coord.x - 5, coord.y - 5]);
        const bot_right = map.unproject([coord.x + 5, coord.y + 5]);
        return (
            <Rectangle
                key={ID}
                color={color}
                bounds={[top_left, bot_right]}
                weight={1}
                fillOpacity={1.0}

                eventHandlers={{
                    click: onClickCallback
                }}
            />
        )
    }
    return (
        <CircleMarker
            key={`circle-${ID}`}
            radius={5}
            color={"black"}
            fillColor={color}
            weight={1}
            fillOpacity={1.0}
            center={position}
            eventHandlers={{
                click: onClickCallback
            }}
        />
    )
}
const Player = ({player, mapSize, refHeight, teamID, cb}) => {
    const color = useMemo(() => getTeamColor(player.teamID, teamID, player.isBot), [player.teamID, teamID, player.isBot]);
    const position = [ player.y, player.x];
    const textLabel = `${player.name} ${(player.z - refHeight).toFixed(1)}m ${player.weapon} ${player.health > 0.0 ? player.health.toFixed(0) : player.groggyHealth.toFixed(0)}`;
    const key = `label-${player.name}-${player.teamID}-${player.id}-${color}`;
    // console.log("player", player.name, player.teamID, color);
    if (player.health === 0.0 && player.groggyHealth === 0.0) {
        return null;
    }
    return (
        <>
            <PlayerShape
                position={position}
                color={color}
                rectangle={player.health === 0.0}
                onClickCallback={cb}
                key={key}
                ID={key}
            />

            <TextLabel
                labelID={key}
                position={position}
                text={textLabel}
                onClickCallback={cb}
            />
        </>
    )
}

export default memo(Player);
